import IShouldReturnEntity from '../../api-clients/IShouldReturnEntity';
import { Entry } from 'contentful';
import { ApplicationSettings } from '../../models/settings';
import BaseComponentModel from './base-component-model';
import { ExcludedEntitiesHelper } from '../../api-clients/page-template-clients/helpers/excluded-entities-helper';
import { ICoursePricing } from '../course/ICourseData';

export default class ApplicationFeeComponentModel extends BaseComponentModel {
  applicationFeeID?: string;
  title: string;
  name: string;
  programLevel: string;
  academicYear?: string;
  applicationFee?: ICoursePricing;
  appSettings: ApplicationSettings;

  public excludedEntitiesHelper = new ExcludedEntitiesHelper();
  public component = 'ApplicationFee';

  protected shouldReturnEntity(entry: Entry<any>): IShouldReturnEntity {
    const requiredFields = [];
    const notEmptyFields = [];

    return this.excludedEntitiesHelper.shouldComponentBeReturned(
      this.component,
      entry,
      requiredFields,
      notEmptyFields,
    );
  }

  id?: string;
  constructor(data: any, appSettings: ApplicationSettings) {
    super('applicationFee', appSettings);

    const applicationFeeShouldReturn = this.shouldReturnEntity(data);

    if (!applicationFeeShouldReturn.shouldReturn) {
      this.exclusionReasons.push(...applicationFeeShouldReturn.shouldNotReturnReasons);
      this.isValid = false;
      return;
    }

    this.applicationFeeID = data.id;
    this.title = data.title;
    this.name = data.name;
    this.programLevel = data.programLevel;
    this.academicYear = data.academicYear;
    this.applicationFee = data.applicationFee;
    this.appSettings = appSettings;
  }
}
